module.exports = __webpack_public_path__ + "static/media/img3.9308b6b5.jpg";